import { ref } from 'vue';

// Estado GLOBAL da janela flutuante do copiloto (singleton de modulo).
// A janela vive montada no Dashboard (v-show), entao a thread sobrevive ao
// fechar/reabrir; aqui mora so o aberto/fechado + o aviso de resposta pronta.
const isOpen = ref(false);
const hasUnread = ref(false);

export function useBrainCopilot() {
  const open = () => {
    isOpen.value = true;
    hasUnread.value = false;
  };
  const close = () => {
    isOpen.value = false;
  };
  const toggle = () => {
    if (isOpen.value) close();
    else open();
  };
  // resposta chegou com a janela fechada -> pontinho no toggle do topbar
  const markUnread = () => {
    if (!isOpen.value) hasUnread.value = true;
  };

  return { isOpen, hasUnread, open, close, toggle, markUnread };
}
